import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { api_url } from "../globalFunction/global_string";

const SelectTenableUser = ({ id, name, requiredAPI, handleUserSelectChange, selectnet, local_net_name, local_unit_name, parentName, selectedName }) => {
  const [options, setOptions] = useState([]);
  const current_user_type = localStorage.getItem('login_user_type');

  useEffect(() => {
    loadData();
  }, [selectnet, local_net_name, local_unit_name]);

  const loadData = () => {
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();

    switch (parentName) {
      case 'superS':
      case 'superM':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_name", local_unit_name);
        break;
      case 'superN':
        formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
        formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
        formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'));
        formData.append("user_type", localStorage.getItem('login_user_type'));
        break;
      default:
        break;
    }


    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        const rows = Array.isArray(data.row) ? data.row : [data.row];
        setOptions(rows);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedName = event.target.options[selectedIndex].text;
    handleUserSelectChange({ name, value, selectedName });
  };

  return (
    <Input
      id={id}
      name={name}
      onChange={handleSelectChange}
      type='select'
      value={selectedName} // 使用 prop 設置選擇的值
    >
      <option key="0" value="">
        請選擇
      </option>
      {options.map(option => (
        <option key={option.user_id} value={option.user_id}>
          {option.user_name}
        </option>
      ))}
    </Input>
  );
};

export default SelectTenableUser;
